import { render, staticRenderFns } from "./we-circular.vue?vue&type=template&id=35c4a18c&"
import script from "./we-circular.vue?vue&type=script&lang=js&"
export * from "./we-circular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports